import styles from './style.module.scss'
import React from 'react'
import { Form, Select } from 'antd'
import { SelectProps } from 'antd/lib/select'

type SelectGlobalProps = SelectProps & {
  selectType?: boolean
  label: string  | React.ReactNode
  labelCol?: { span: number }
  wrapperCol?: { span: number }
  validateStatus?: 'error' | 'warning' | 'validating' | 'success' | null
  help?: React.ReactNode
  component?: React.ReactNode
}

const SelectGlobal: React.FC<SelectGlobalProps> = ({
  validateStatus,
  help,
  className,
  selectType = false,
  size = 'large',
  label,
  labelCol,
  wrapperCol,
  style,
  component,
  ...props
}) => {
  return (
    <Form.Item
      style={style ? style : { margin: 0, marginBottom: 20 }}
      className={className ? className : styles.customSelect}
      label={label}
      {...(labelCol ? { labelCol } : {})}
      {...(wrapperCol ? { wrapperCol } : {})}
      {...(validateStatus ? { validateStatus } : {})}
      {...(help ? { help } : {})}
    >
      <Select size={size} {...props} />
    </Form.Item>
  )
}

export default SelectGlobal
